import { render, staticRenderFns } from "./App.vue?vue&type=template&id=72046b1f&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72046b1f')) {
      api.createRecord('72046b1f', component.options)
    } else {
      api.reload('72046b1f', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=72046b1f&", function () {
      api.rerender('72046b1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/App.vue"
export default component.exports